import React, { useEffect, useState } from 'react'
import { captureException } from '@sentry/browser'

import { Pagination } from 'components'
import { findProductByIds } from 'features/Product'
import TicketProductStructure from './TicketProductStructure'

import type { Product, ProductInfoProps } from './model'

const TicketProductInfo: React.FC<ProductInfoProps> = (props) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const {
    productIds,
    ticketDetail,
    products,
    onOpenHistoryModal,
    setProducts,
  } = props
  const base = 'f-ticket-product-info'

  useEffect(() => {
    setIsLoading(true)

    if (productIds && productIds.length) {
      fetchProducts(productIds)
    }
  }, [productIds])

  const fetchProducts = async (ids: string[]) => {
    try {
      const { data } = await findProductByIds(ids)

      const products = data as Product[]

      setProducts(products)
      setIsLoading(false)
    } catch (error) {
      captureException(error)
    }
  }

  return (
    <div className={base} data-testid='ticket-product-info'>
      {products
        .filter((_, index: number) => index + 1 === currentPage)
        .map((product, indexInner) => {
          return (
            <TicketProductStructure
              key={indexInner}
              product={product}
              ticketDetail={ticketDetail}
              isLoading={isLoading}
              onOpenHistoryModal={onOpenHistoryModal}
            />
          )
        })}

      <div className={`${base}__pagination`}>
        <Pagination
          currentPage={currentPage}
          totalPages={products.length}
          disabled={isLoading}
          onChange={(page) => setCurrentPage(page)}
          isTaskDetail
        />
      </div>
    </div>
  )
}

export default TicketProductInfo
